import "core-js/modules/es.array.concat.js";
import request from '@/utils/request';
import { getCookie } from '@/utils/cookie';
var baseUrl = '//a.rednet.cn';
var wechatUrl = '//weixin.rednet.cn';
var wechatShareUrl = '//weixin.rednet.cn';
var passportUrl = '//passport.rednet.cn';

// var baseUrl = '//a.onlyred.net'
// var wechatUrl = '//weixin.onlyred.net'
// var wechatShareUrl = '//weixin.onlyred.net'
// var passportUrl = '//passport.onlyred.net'

var host = window.location.host;
if (host.indexOf('moment.rednet.cn') != -1) {
  baseUrl = '//f.rednet.cn';
}
export function liveDetail(LIVEID, BIZOP) {
  var PAGE = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var ORDER = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var INFOIF = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  if (INFOIF == '') {
    INFOIF = 0;
  }
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    hideloading: true,
    headers: {
      traceid: '1231231',
      bizop: BIZOP,
      biztype: 'onlineLive'
    },
    data: {
      liveId: LIVEID,
      order: ORDER,
      pageNo: PAGE,
      liveInfoId: INFOIF
    }
  });
}
export function liveNewList(LIVEID, BIZOP, INFOIF, ORDER) {
  if (INFOIF == '') {
    INFOIF = 0;
  }
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    hideloading: true,
    headers: {
      traceid: '1231231',
      bizop: BIZOP,
      biztype: 'onlineLive'
    },
    data: {
      liveId: LIVEID,
      order: ORDER,
      liveInfoId: INFOIF
    }
  });
}

/**
 * 添加访问量
 */
export function addVisit(data) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    headers: {
      version: '8.0',
      traceid: '1231231',
      userId: userId ? userId : "EWYCZpEDqvLvMhdqygXLAA==",
      bizop: 'createModelLog',
      biztype: 'serviceInfo'
    },
    data: data
  });
}

/**
 * 客户端评论
 * @description 客户端评论分页
 * **/
export function clientCommentList(data, userId) {
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    hideloading: true,
    headers: {
      traceid: '1231231',
      userId: userId,
      bizop: 'queryLiveCommentList2',
      biztype: 'onlineLiveComment'
    },
    data: data
  });
}
export function commentList(data) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    headers: {
      traceid: '1231231',
      userId: userId,
      bizop: 'queryShareLiveCommentList',
      biztype: 'onlineLiveComment'
    },
    data: data
  });
}
export function liveZan(LIVEID, TOLIVEID) {
  if (TOLIVEID == '') {
    TOLIVEID = 0;
  }
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    headers: {
      traceid: '1231231',
      bizop: 'starOnlineLiveInfo',
      biztype: 'onlineLive'
    },
    data: {
      liveId: LIVEID,
      liveInfoId: TOLIVEID
    }
  });
}
export function wechatLogin(uniacid) {
  var options = {
    url: wechatUrl + '/ci/front/login/index',
    method: 'post',
    headers: {},
    data: {
      from: 'wechat',
      uniacid: uniacid,
      scope: 'userinfo',
      tcode: getCookie('tcode'),
      callback: window.location.href
    }
  };
  return request(options);
}
export function qqLogin() {
  var options = {
    url: wechatUrl + '/ci/front/login/index',
    method: 'post',
    headers: {},
    data: {
      from: 'qq',
      scope: 'userinfo',
      tcode: getCookie('tcode'),
      callback: window.location.href
    }
  };
  return request(options);
}
export function wechatShare(uniacid) {
  return request({
    url: "".concat(wechatShareUrl, "/app/index.php?i=").concat(uniacid, "&c=entry&do=getjssdk&m=redoauth&jsurl=") + encodeURIComponent(window.location.href.split('#')[0]),
    headers: {},
    method: 'get'
  });
}
export function comment(data) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EWYCZpEDqvLvMhdqygXLAA==';
  //pwPIWXhEArtjvRY9uR79NA==
  console.log(111, userId);
  if (userId) {
    return request({
      url: baseUrl + '/dispatch',
      method: 'post',
      headers: {
        traceid: '1231231',
        bizop: 'createComment',
        biztype: 'onlineLiveComment',
        userId: userId
      },
      data: data
    });
  } else {
    return request({
      url: baseUrl + '/dispatch',
      method: 'post',
      headers: {
        traceid: '1231231',
        bizop: 'createComment',
        biztype: 'onlineLiveComment'
      },
      data: data
    });
  }
}
export function commentEmoji(data) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'EWYCZpEDqvLvMhdqygXLAA==';
  //EWYCZpEDqvLvMhdqygXLAA==
  if (userId) {
    return request({
      url: baseUrl + '/dispatch',
      method: 'post',
      hideloading: true,
      headers: {
        traceid: '1231231',
        bizop: 'createCommentNotCheckToEmote',
        biztype: 'onlineLiveComment',
        userId: userId
      },
      data: data
    });
  } else {
    return request({
      url: baseUrl + '/dispatch',
      method: 'post',
      hideloading: true,
      headers: {
        traceid: '1231231',
        bizop: 'createCommentNotCheckToEmote',
        biztype: 'onlineLiveComment'
      },
      data: data
    });
  }
}
export function getUserInfoByToken(token) {
  var options = {
    url: "".concat(passportUrl, "/passport/user/getUserInfo"),
    method: 'get',
    params: {
      token: token
    }
  };
  return request(options);
}
export function getEmojiList(siteId) {
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    headers: {
      traceid: '1231231',
      bizop: 'queryOnlineLiveEmote',
      biztype: 'onlineLive'
    },
    data: {
      siteId: siteId
    }
  });
}
export function liveTotalZan(LIVEID) {
  return request({
    url: baseUrl + '/dispatch',
    method: 'post',
    hideloading: true,
    headers: {
      traceid: '1231231',
      bizop: 'starOnlineLive',
      biztype: 'onlineLive'
    },
    data: {
      liveId: LIVEID
    }
  });
}